import { render, staticRenderFns } from "./PhotoCellTab.vue?vue&type=template&id=6f4ffe8b&scoped=true&"
import script from "./PhotoCellTab.vue?vue&type=script&lang=js&"
export * from "./PhotoCellTab.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCellTab.vue?vue&type=style&index=0&id=6f4ffe8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ffe8b",
  null
  
)

export default component.exports